import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getChapterName } from 'src/Helpers/helperFunction';
import { breadcrumAction } from 'src/Redux/Action/breadcrumAction';
import { contentTypeAction } from 'src/Redux/Action/htmlAction';
import { userReadHistoryService } from 'src/Services/ApiHandlers/userReadHistory';
import { Storage } from 'src/Storage';
import Iconify from 'src/components/Iconify';
import BorderLinearProgress from 'src/components/common/BorderLinearProgress';
// import { renderTypeObj } from 'src/Helpers/constant';

const HtmlListing = ({ chapterListing, setChapterListing, singleBookItem, menuType, isClone, scrollbar = false }) => {
  const userLoggedIn = Storage.get('authToken') && JSON.parse(Storage.get('authToken'));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [readHistory, setReadHistory] = useState([]);

  const history = (path) => {
    navigate(path, { state: { menuType } });
  };

  const params = useParams();

  const bookName = isClone ? params.id : singleBookItem?.slug;

  const scrollbarObj = {};

  if (scrollbar) {
    scrollbarObj.maxHeight = '40vh';
    scrollbarObj.overflowY = 'auto';
  }

  const getUserHistory = (id) => {
    if (!userLoggedIn) return;
    userReadHistoryService.getHistoryByBookId(id).then((response) => {
      if (response.code === 200) {
        setReadHistory(response.data);
      }
    });
  };

  useEffect(() => {
    if (singleBookItem) {
      getUserHistory(singleBookItem._id);
    }
  }, [singleBookItem]);

  const getHistoryProgressValue = (id) => {
    const history = readHistory.find((item) => item.content_id === id && item.book_id === singleBookItem._id);
    if (history) {
      if (history.status === 1) {
        const isChapter = history.content_type === 'chapters';
        if (isChapter) {
          const headerList = singleBookItem.index[0].chapter_data.find((item) => item._id === id);
          const isHeadersRead = headerList.header_data.every((header) => {
            const isHeaderRead = readHistory.find(
              (item) => item.content_id === header._id && item.book_id === singleBookItem._id
            );
            return isHeaderRead && isHeaderRead.status === 1;
          });

          if (isHeadersRead) {
            return 100;
          }
          return 50;
        }
        return 100;
      } else {
        return 50;
      }
    } else {
      return 0;
    }
  };

  const getHistoryStyle = (id) => {
    const history = readHistory.find((item) => item.content_id === id && item.book_id === singleBookItem._id);
    if (history) {
      if (history.status === 1) {
        const isChapter = history.content_type === 'chapters';
        if (isChapter) {
          const headerList = singleBookItem.index[0].chapter_data.find((item) => item._id === id);
          const isHeadersRead = headerList.header_data.every((header) => {
            const isHeaderRead = readHistory.find(
              (item) => item.content_id === header._id && item.book_id === singleBookItem._id
            );
            return isHeaderRead && isHeaderRead.status === 1;
          });

          if (isHeadersRead) {
            return 'green';
          }
          return '#ff9000';
        }
        return 'green';
      } else {
        return '#ff9000';
      }
    } else {
      return 'black';
    }
  };

  return (
    <React.Fragment>
      {chapterListing && chapterListing.length > 0 && (
        <ul style={scrollbarObj}>
          {chapterListing.map((item, key) => {
            return (
              <li
                key={key}
                style={{
                  backgroundColor: item.isCheck ? '#F6F7FE' : 'white',
                  borderLeft: item.isCheck ? '5px solid #1434cb' : 'none',
                  fontWeight: item.isCheck ? 'bold' : 'normal',
                }}
              >
                <div className="d-flex align-items-center">
                  <div
                    className="me-2"
                    onClick={() => {
                      let array = [...chapterListing];
                      array.forEach((inner, kys) => {
                        if (kys === key) {
                          inner.isCheck = !inner.isCheck;
                        }
                      });
                      setChapterListing(array);
                      dispatch(breadcrumAction([]));
                      dispatch(
                        contentTypeAction({
                          renderType: 'instructor',
                          id: singleBookItem?._id,
                          htmltype: menuType,
                          mainid: item._id,
                          type: item.type ? item.type : 'chapter',
                          routerType: 'CHAPTER',
                          bookItemObj: item,
                        })
                      );
                    }}
                  >
                    {item.header_data.length > 0 ? (
                      <span>
                        {item.isCheck ? (
                          <Iconify icon="eva:arrow-down-fill" width={24} height={24} />
                        ) : (
                          <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                        )}
                      </span>
                    ) : (
                      <span>
                        <Iconify icon="radix-icons:dot-filled" width={24} height={24} />
                      </span>
                    )}
                  </div>

                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: {
                        xs: 'column',
                        md: 'row',
                      },
                      justifyContent: 'space-between',
                      alignItems: {
                        xs: 'flex-start',
                        md: 'center',
                      },
                      gap: 2,
                    }}
                  >
                    <div
                      className="flex-grow-1 text-start"
                      onClick={() => history(`/library/${bookName}/${item.slug}`)}
                      style={{ color: getHistoryStyle(item._id) }}
                    >
                      {item.chapter_name_clone || item.chapter_name}
                    </div>
                    <BorderLinearProgress color={getHistoryStyle(item._id)} value={getHistoryProgressValue(item._id)} />
                  </Box>
                </div>

                {item.isCheck &&
                  item.header_data.length > 0 &&
                  item.header_data.map((headerone, hkeyone) => {
                    return (
                      <ul style={{ fontWeight: 'normal', marginLeft: '1rem' }} className="ps-2" key={hkeyone}>
                        <li>
                          <div
                            className="d-flex"
                            onClick={() => {
                              let array = [...chapterListing];
                              array[key].header_data[hkeyone].isCheck = !headerone.isCheck;
                              setChapterListing(array);
                              dispatch(breadcrumAction([]));
                              dispatch(
                                contentTypeAction({
                                  renderType: 'instructor',
                                  id: singleBookItem?._id,
                                  htmltype: menuType,
                                  mainid: headerone._id,
                                  type: headerone.type ? headerone.type : 'chapter',
                                  routerType: 'HEADER',
                                  bookItemObj: headerone,
                                })
                              );
                            }}
                          >
                            {headerone.header_data.length > 0 ? (
                              <span>
                                {headerone.isCheck ? (
                                  <Iconify icon="eva:arrow-down-fill" width={24} height={24} />
                                ) : (
                                  <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                                )}
                              </span>
                            ) : (
                              <span>
                                <Iconify icon="radix-icons:dot-filled" width={24} height={24} />
                              </span>
                            )}

                            <Box
                              sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: {
                                  xs: 'column',
                                  md: 'row',
                                },
                                justifyContent: 'space-between',
                                alignItems: {
                                  xs: 'flex-start',
                                  md: 'center',
                                },
                                gap: 2,
                              }}
                            >
                              <span
                                onClick={() => navigate(`/library/${bookName}/${item.slug}/${headerone.slug}`)}
                                style={{ color: getHistoryStyle(item._id) }}
                              >
                                {headerone.header_name}
                              </span>
                              <BorderLinearProgress
                                color={getHistoryStyle(headerone._id)}
                                value={getHistoryProgressValue(headerone._id)}
                              />
                            </Box>
                          </div>
                        </li>

                        {headerone.isCheck &&
                          headerone.header_data.length > 0 &&
                          headerone.header_data.map((headertwo, hkeytwo) => {
                            return (
                              <ul className="ps-2" key={hkeytwo}>
                                <li>
                                  <div
                                    className="d-flex"
                                    onClick={() => {
                                      let array = [...chapterListing];
                                      array[key].header_data[hkeyone].header_data[hkeytwo].isCheck = !headertwo.isCheck;
                                      setChapterListing(array);
                                      dispatch(breadcrumAction([]));
                                      dispatch(
                                        contentTypeAction({
                                          renderType: 'instructor',
                                          id: singleBookItem?._id,
                                          htmltype: menuType,
                                          mainid: headertwo._id,
                                          type: headertwo.type ? headertwo.type : 'chapter',
                                          routerType: 'HEADER',
                                          bookItemObj: headertwo,
                                        })
                                      );
                                    }}
                                  >
                                    {headertwo.header_data.length > 0 ? (
                                      <span>
                                        {headertwo.isCheck ? (
                                          <Iconify icon="eva:arrow-down-fill" width={24} height={24} />
                                        ) : (
                                          <Iconify icon="eva:arrow-right-fill" width={24} height={24} />
                                        )}
                                      </span>
                                    ) : (
                                      <span>
                                        <Iconify icon="radix-icons:dot-filled" width={24} height={24} />
                                      </span>
                                    )}

                                    <span
                                      onClick={() =>
                                        navigate(
                                          `/library/${bookName}/${item.slug}/${headerone.slug}/${headertwo.slug}`
                                        )
                                      }
                                    >
                                      {headertwo.header_name}
                                    </span>
                                  </div>
                                </li>

                                {headertwo.isCheck &&
                                  headertwo.header_data &&
                                  headertwo.header_data.length > 0 &&
                                  headertwo.header_data.map((headerthree, hkeythree) => {
                                    return (
                                      <ul key={hkeythree} className="ps-2">
                                        <li>
                                          <div
                                            className="d-flex"
                                            onClick={() => {
                                              let array = [...chapterListing];
                                              array[key].header_data[hkeyone].header_data[hkeytwo].header_data[
                                                hkeythree
                                              ].isCheck = !headerthree.isCheck;
                                              setChapterListing(array);
                                              dispatch(breadcrumAction([]));
                                              dispatch(
                                                contentTypeAction({
                                                  renderType: 'instructor',
                                                  id: singleBookItem?._id,
                                                  htmltype: menuType,
                                                  mainid: headerthree._id,
                                                  type: headerthree.type ? headerthree.type : 'chapter',
                                                  routerType: 'HEADER',
                                                  bookItemObj: headerthree,
                                                })
                                              );
                                            }}
                                          >
                                            <span
                                              onClick={() =>
                                                navigate(
                                                  `/library/${bookName}/${item.slug}/${headerone.slug}/${headertwo.slug}/${headerthree.slug}`
                                                )
                                              }
                                            >
                                              {headerthree.header_name}
                                            </span>
                                          </div>
                                        </li>
                                      </ul>
                                    );
                                  })}
                              </ul>
                            );
                          })}
                      </ul>
                    );
                  })}
              </li>
            );
          })}
        </ul>
      )}

      {chapterListing && chapterListing.length <= 0 && <p>No Chapter Available</p>}
    </React.Fragment>
  );
};

export default HtmlListing;
